export default __webpack_public_path__ + "images/fastpath-white-mono.svg";